import { ViewController, JsonFeed, ModelUpdateEvent, DataReceiveEvent, MaintenanceEvent, CustomerIntegrationController,
         VideoReloadEvent, TimeUpdateEvent, ChannelSwitchEvent, BetPlaceEvent, TimeoutEvent,
         RelayoutEvent, WIDGET_LIVETABLE } from "@gaming/srvg-classes-core";
import { WideView } from "../../View/AppView/WideView";
import { LiveSettlementsViewController } from "./LiveSettlementsViewController";
import { TimelineController } from "../TimelineController";
import { OddsfeedController } from "../OddsfeedController";
import { MatchIdsFeedController } from "../MatchIdsFeedController";
import { LiveTableController } from "../LiveTableController";
import { OverlayViewController } from "./OverlayViewController";
import { TitlebarController } from "./TitlebarController";
import { VideoController } from "./VideoController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class WideViewController extends ViewController {
    wideView: WideView;

    liveTableController: LiveTableController;
    overlayViewController: OverlayViewController;
    titlebarController: TitlebarController;
    videoController: VideoController;
    matchdayAreaController: MatchdayAreaController;
    liveSettlementsViewController: LiveSettlementsViewController;

    constructor( options ) {
        options = options || {};
        options.view = options.wideView || null;
        super( options );
        this.name = 'vblWideViewController';

        this.wideView = options.wideView || null;

        /******************* initialize controllers ************************/

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.wideView.videoView,
            videoControlBar: this.wideView.videoControlBar,
            channel: srvg.videooptions.defaultchannel
        } ) );

        app.timelineController       = new TimelineController( { url: srvg.url.timeline } );
        app.oddsfeedController       = new OddsfeedController({
            feed: new JsonFeed( { url: srvg.url.oddsfeed } ),
            maxSize: 60
        });
        app.matchIdsFeedController = new MatchIdsFeedController( {
            feed: new JsonFeed( { url: srvg.url.matchidsfeed } ),
            maxSize: 60
        } );
        this.titlebarController       = this.addChildViewController( new TitlebarController( { titlebar: this.wideView.titlebar } ) );
        app.customerIntegration       = new CustomerIntegrationController( {} );
        srvg.customerIntegration      = app.customerIntegration;
        this.liveTableController      = this.addChildViewController( new LiveTableController( {
            button: '#livetable_button',
            liveTable: this.wideView.liveTable,
            liveTableWidget: srvg.widgets[WIDGET_LIVETABLE].enabled ? this.wideView.widgetLivetable : null
        }) );
        this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
            overlayView: this.wideView.overlayContainerView,
            teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
            teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
        } ) );

        this.matchdayAreaController = this.addChildViewController( new MatchdayAreaController({
            matchdayArea: this.wideView.matchdayArea
        }) );

        /******************* connect components ************************/

        if( this.wideView.matchdayArea.matchdayPicker ) {
            // FIXME move
            this.wideView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.customerIntegration, ModelUpdateEvent );
            app.inactivityController.addSubscriberForEvent( this.matchdayAreaController.matchdaypickerController, TimeoutEvent );
        }
        this.wideView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.oddsfeedController, ModelUpdateEvent );
        this.wideView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );
        app.matchIdsFeedController.addSubscriberForEvent( app.customerIntegration, DataReceiveEvent );

        app.oddsfeedController.addSubscriberForEvent( this.matchdayAreaController, DataReceiveEvent );
        app.timelineController.addSubscriberForEvent( srvg.maintenance, MaintenanceEvent );

        app.timelineController.addSubscriberForEvent( app.customerIntegration,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.titlebarController,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( app.server,                 TimeUpdateEvent );
        app.timelineController.addSubscriberForEvent( this.overlayViewController, PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,       VideoReloadEvent );

        app.inactivityController.addSubscriberForEvent( this.titlebarController, TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( app.timelineController,  TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( this.videoController,    TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( app.customerIntegration, TimeoutEvent );

        this.wideView.matchdayArea.oddsGallery.addSubscriberForEvent( app.customerIntegration, BetPlaceEvent );

        var exch = srvg.eventExchange;


        if( srvg.widgets[WIDGET_LIVETABLE].enabled ) {
            this.wideView.liveTable.addSubscriberForEvent(this.liveTableController, RelayoutEvent);
        }
        if( srvg.widgets['livesettlements'].enabled){
            this.liveSettlementsViewController = this.addChildViewController(
                new LiveSettlementsViewController({livesettlementWidget: this.wideView.widgetLivesettlements})
            );
        }

        exch.addEventHandler(this.videoController,             'all',                          ChannelSwitchEvent );
        exch.addEventHandler(this.overlayViewController,       'all',                          ChannelSwitchEvent );
        exch.addEventHandler(app.customerIntegration,          'all',                          ChannelSwitchEvent );

        /******************* start components ************************/
        app.timelineController.startPolling();
        app.inactivityController.startWaiting();
        this.videoController.play();
        app.customerIntegration.startCustomerActions();
    }
}